import { createSlice } from "@reduxjs/toolkit";
import { ROLE } from "src/config/constants";

let userInfoKey = `${ROLE}-userInfo`;

const userInfo = JSON.parse(window.localStorage.getItem(userInfoKey) || "{}");

const initialState = {
  userInfo,
  isLoggedIn: !!userInfo.token,
};

// console.log('initialState', initialState)

const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    updateUserInfo(state, action) {
      // console.log("action", action);
      state.userInfo = {
        ...state.userInfo,
        ...action.payload,
      };

      window.localStorage.setItem(userInfoKey, JSON.stringify(state.userInfo));
    },
    login(state, action) {
      state.userInfo = action.payload;
      state.isLoggedIn = true;

      window.localStorage.setItem(userInfoKey, JSON.stringify(state.userInfo));
    },
    logout(state, action) {
      state.userInfo = {};
      state.isLoggedIn = false;


      window.localStorage.removeItem(userInfoKey);
      // window.localStorage.clear();
    }
  },
});

export const { updateUserInfo, login, logout } = userInfoSlice.actions;

export default userInfoSlice.reducer;
